import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet, ScrollView } from '../utils/webComponents';
import { Close, Check } from '@mui/icons-material';
import { useTheme } from '../context/ThemeContext';
import { useLanguage } from '../context/LanguageContext';
import { useTranslation } from '../hooks/useTranslation';

const LanguageModal = ({ visible, onClose }) => {
  const { theme } = useTheme();
  const { language, changeLanguage, availableLanguages, getCurrentLanguageName } = useLanguage();
  const { t } = useTranslation();

  if (!visible) return null;

  const handleLanguageSelect = (languageCode) => {
    changeLanguage(languageCode);
    onClose();
  };

  return (
    <View style={styles.overlay} onClick={(e) => e.target === e.currentTarget && onClose()}>
      <View style={[styles.modal, { backgroundColor: theme.surface }]}>
        <View style={styles.header}>
          <Text style={[styles.title, { color: theme.text }]}>{t('settings.language')}</Text>
          <TouchableOpacity style={styles.closeButton} onPress={onClose}>
            <Close sx={{ fontSize: 24, color: theme.textMuted }} />
          </TouchableOpacity>
        </View>

        <ScrollView style={styles.list}>
          {Object.entries(availableLanguages).map(([code, name]) => {
            const isSelected = language === code;
            return (
              <TouchableOpacity
                key={code}
                style={[
                  styles.languageItem,
                  { 
                    backgroundColor: theme.surface,
                    borderBottomColor: theme.border,
                  },
                  isSelected && { backgroundColor: theme.primaryLight }
                ]}
                onPress={() => handleLanguageSelect(code)}
              >
                <Text style={[
                  styles.languageName,
                  { color: theme.text },
                  isSelected && { color: theme.primary, fontWeight: '600' }
                ]}>
                  {name}
                </Text>
                {isSelected && <Check sx={{ fontSize: 20, color: theme.primary }} />}
              </TouchableOpacity>
            );
          })}
        </ScrollView>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1500,
  },
  modal: {
    width: '90%',
    maxWidth: 400,
    borderRadius: 16,
    padding: 24,
    maxHeight: '80%',
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 16,
  },
  title: {
    fontSize: 20,
    fontWeight: '700',
  },
  closeButton: {
    padding: 4,
  },
  list: {
    maxHeight: 400,
  },
  languageItem: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 16,
    paddingHorizontal: 16,
    borderBottomWidth: 1,
  },
  languageName: {
    fontSize: 16,
  },
});

export default LanguageModal;
